import { MappedAnswer } from '../../components/context/SurveyPageContext';

interface Upsert {
  answer: MappedAnswer;
  mappedAnswers: Map<number, MappedAnswer>;
}

const upsert = ({ answer, mappedAnswers }: Upsert): Map<number, MappedAnswer> => {
  const answers = new Map(mappedAnswers);
  answers.set(answer.question.id, answer);
  return answers;
};

export { upsert };
